// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskBindingTaskVersion } from './taskBindingTaskVersion';

/**
 * Reference to a concrete task (with optional version).
 */
export interface TaskBinding {
  task_id: string;
  /** Concrete task version or any */
  task_version?: TaskBindingTaskVersion;
}
